module.exports = __webpack_public_path__ + "77e01b4bebe144de8ba41d967d207f4f.pdf";